export default require("color");
